import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

class ScrollLink {
  constructor() {
    this.links = document.querySelectorAll("[data-scroll-link]");
    this.init();
  }

  init() {
    if (this.links && this.links.length) {
      this.links.forEach((link) => {
        const target = link.getAttribute("data-scroll-link");
        link.addEventListener("click", (evt) => {
          evt.preventDefault();
          const targetElement = document.querySelector(`${target}`);
          if (targetElement) {
            gsap.to(window, {
              duration: 1.2,
              scrollTo: {
                y: targetElement.offsetTop - link.getBoundingClientRect().height,
              },
              ease: "power3.out",
            });
          }
        });
      });
    }
  }
}

export default ScrollLink;
